import Vue from 'vue'

export default {
  fetchOrganizationCompanies({ organizationId }) {
    return Vue.http.get(`app-services/v2/organizations/${organizationId}/companies`)
  }
}
